import React, { useState, useEffect } from 'react';
import PaginationComponent from '../Desenganche/pagination';
import moment from 'moment';

const TableComponent = props => 
{
  const { data } = props;
  const [dataPagination, setDataPagination] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 800);
  }, []);

  let handleSearch = '';
  let filteredData = '';

  useEffect(() => 
  {
    setTimeout(() => {}, 800);
  }, [data]);

  handleSearch = (event) => {
    const inputValue = event.target.value || '';
    setSearchTerm(inputValue);
  };

  filteredData = dataPagination.filter((row) =>
    Object.values(row).some((value) =>
      value !== null && value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  let filteredResults = filteredData;
  let valor;
  if (filteredResults.length === 0) {
    valor = true;
  }

  return (
    loading ? (
      <div className="cargando">
        <div className="loader" id="loader">
          Loading...
        </div>
      </div>
    ) : (
      <div>
        <style jsx>{`
          .tabla {
            width: 100%;
            table-layout: auto;
          }

          .tabla th, .tabla td {
            white-space: nowrap; /* Esto hace que el contenido no se rompa en múltiples líneas */
            text-align: left;
            padding: 8px;
          }

          .tabla th {
            background-color: #f2f2f2;
            font-weight: bold;
          }

          .tabla tr:nth-child(even) {
            background-color: #f9f9f9;
          }

          .buscar {
            margin-bottom: 10px;
          }

          .cargando {
            text-align: center;
            margin-top: 50px;
          }

          .table-container {
            overflow-x: auto; /* Permite el scroll horizontal */
          }
        `}</style>
        {data.length > 0  ? (
          <>
            {/* <Row className="justify-content-end mbottom-40">
              <input className='buscar inputplaca' type="text" placeholder="Search..." onChange={handleSearch} />
            </Row> */}
            <div className="table-container">
              <table className='tabla'>
                <thead>
                  <tr>
                    <th>FACTURA</th>
                    <th>ANEXOS</th>
                    <th>FECHA REGISTRO</th>
                    <th>ESTADO</th>
                    <th>COMENTARIO</th>
                    <th>CUFE</th>
                    <th>QR</th>
                    <th>FECHA ENVIO</th>
                    <th>DESCRIPCION</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map((row) => (
                    <tr key={row.numero_factura_sap}>
                      <td>{row.numero_factura_sap}</td>
                      <td>{row.anexos}</td>
                      <td>{moment.utc(row.fecha_registro).format('DD-MM-YYYY HH:mm:ss')}</td>
                      <td>{row.estado}</td>
                      <td>{row.observacion}</td>
                      <td>{row.cufe}</td>
                      <td>{row.qr}</td>
                      <td>{ (row.fecha_envio ?  moment.utc(row.fecha_envio).format('DD-MM-YYYY HH:mm:ss') : '')}</td>
                      <td>{row.mensaje}</td>

                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="float-right pagination">
              <PaginationComponent
                data={data}
                setDataPagination={setDataPagination}
                title="Posts"
                pageLimit={10}
                dataLimit={50}
              />
            </div>
          </>
        ) : null}
      </div>
    )
  );
};

export default TableComponent;
